import { GenerateLeadSubmissionPaymentLinkPayload } from "interfaces/lead-submission";

export type PartnerPaywallVariant = "chowbus";
export type PartnerActivateSurface = "default_activate" | "partner_paywall";
export type PartnerKey = "chowbus";

export type PartnerExperienceConfig = {
  activateSurface: PartnerActivateSurface;
  selfCampaignPlanName: GenerateLeadSubmissionPaymentLinkPayload["planName"];
  paywallVariant: PartnerPaywallVariant;
  paywallCtaLabel: string;
};

export const normalizePartnerIdentifier = (
  value?: string | null,
): string | undefined => {
  if (typeof value !== "string") {
    return undefined;
  }

  const normalized = value.trim().toLowerCase();
  return normalized.length > 0 ? normalized : undefined;
};

export const PARTNER_EXPERIENCES: Record<PartnerKey, PartnerExperienceConfig> = {
  chowbus: {
    activateSurface: "partner_paywall",
    selfCampaignPlanName: "talk-town",
    paywallVariant: "chowbus",
    paywallCtaLabel: "Start My Free Campaign",
  },
};

const isPartnerKey = (value: string): value is PartnerKey => {
  return value in PARTNER_EXPERIENCES;
};

export const getPartnerExperience = (
  partner?: string | null,
): PartnerExperienceConfig | undefined => {
  const normalized = normalizePartnerIdentifier(partner);
  if (!normalized || !isPartnerKey(normalized)) {
    return undefined;
  }

  return PARTNER_EXPERIENCES[normalized];
};
